const TEST_STRING = "__storage_test__";

const getLocalStorage: () => Storage | null = () => {
  try {
    const storage = window.localStorage;
    if (!storage) {
      return null;
    }

    storage.setItem(TEST_STRING, TEST_STRING);
    storage.removeItem(TEST_STRING);
    return storage;
  } catch {
    return null;
  }
};

export default getLocalStorage;
